"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3140],{

/***/ 23887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image2; },
/* harmony export */   "Ei": function() { return /* binding */ Img; }
/* harmony export */ });
/* unused harmony exports shouldShowFallbackImage, useImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44040);
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("pending");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useSafeLayoutEffect */ .G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));



/***/ }),

/***/ 73140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OfferPreviewCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/utils/imageAlt.ts
var imageAlt = __webpack_require__(61254);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/Desktop.tsx







const OfferPreviewCardDesktop = _ref => {
  var _offerData$vehicle, _offerData$vehicle$im;

  let {
    offerData
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
    bg: "transparent",
    mt: "0",
    width: "100%",
    templateColumns: "35fr 65fr",
    position: "relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
        borderRadius: "10px",
        width: {
          md: 40
        },
        src: (_offerData$vehicle = offerData.vehicle) === null || _offerData$vehicle === void 0 ? void 0 : (_offerData$vehicle$im = _offerData$vehicle.image) === null || _offerData$vehicle$im === void 0 ? void 0 : _offerData$vehicle$im.path,
        alt: (0,imageAlt/* getOfferCardAlt */.Pr)(offerData.vehicle, 'noleggio a lungo termine')
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      mt: {
        base: 4,
        md: 0
      },
      ml: {
        md: 4
      },
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1rem",
        color: "baseDark",
        display: "inline-block",
        mr: "s",
        children: offerData.vehicle.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Regular",
        color: "baseNeutral.700",
        fontSize: "0.875rem",
        display: "inline-block",
        children: offerData.vehicle.version
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        mt: "s",
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:duration')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: [offerData.contractLength, " ", t('nltCustomizeOfferModalStepsComponent:months')]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:kmPerYear')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:deposit')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: [offerData.deposit.toLocaleString('it-IT'), "\u20AC"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        position: "absolute",
        right: "0",
        bottom: "1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.5rem",
          color: "baseDark",
          align: "right",
          children: ["\u20AC ", offerData.monthlyRate.toLocaleString('it-IT')]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Medium",
          color: "baseNeutral.700",
          fontSize: "0.625rem",
          align: "right",
          children: t('nltCustomizeOfferModalStepsComponent:monthlyTaxExluded')
        })]
      })]
    })]
  });
};

/* harmony default export */ var Desktop = (OfferPreviewCardDesktop);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/Mobile.tsx








const OfferPreviewCardMobile = _ref => {
  var _offerData$vehicle, _offerData$vehicle$im;

  let {
    offerData
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
      bg: "transparent",
      mt: "0",
      width: "100%",
      templateColumns: "35fr 65fr",
      position: "relative",
      spacingX: "m",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        flexShrink: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
          borderRadius: "10px",
          src: (_offerData$vehicle = offerData.vehicle) === null || _offerData$vehicle === void 0 ? void 0 : (_offerData$vehicle$im = _offerData$vehicle.image) === null || _offerData$vehicle$im === void 0 ? void 0 : _offerData$vehicle$im.path,
          alt: (0,imageAlt/* getOfferCardAlt */.Pr)(offerData.vehicle, 'noleggio a lungo termine')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        mt: {
          base: 4,
          md: 0
        },
        ml: "1px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1rem",
          color: "baseDark",
          children: offerData.vehicle.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Regular",
          color: "baseNeutral.700",
          fontSize: "0.875rem",
          children: offerData.vehicle.version
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      mt: "s",
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:duration')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: [offerData.contractLength, " ", t('nltCustomizeOfferModalStepsComponent:months')]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:kmPerYear')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:deposit')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: [offerData.deposit.toLocaleString('it-IT'), "\u20AC"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      position: "absolute",
      right: "5",
      bottom: "7",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.5rem",
        color: "baseDark",
        align: "right",
        children: ["\u20AC ", offerData.monthlyRate.toLocaleString('it-IT')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        color: "baseNeutral.700",
        fontSize: "0.625rem",
        align: "right",
        children: t('nltCustomizeOfferModalStepsComponent:monthlyTaxExluded')
      })]
    })]
  });
};

/* harmony default export */ var Mobile = (OfferPreviewCardMobile);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/index.tsx






const OfferPreviewCard = _ref => {
  let {
    offerData
  } = _ref;
  const isMobile = (0,index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(Mobile, {
    offerData: offerData
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop, {
    offerData: offerData
  });
};

/* harmony default export */ var components_OfferPreviewCard = (OfferPreviewCard);

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 61254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getGalleryImagesAlt; },
/* harmony export */   "KX": function() { return /* binding */ getSellVehicleAltData; },
/* harmony export */   "NB": function() { return /* binding */ UNKNOWN_MAIN_VIEW; },
/* harmony export */   "Pr": function() { return /* binding */ getOfferCardAlt; },
/* harmony export */   "fU": function() { return /* binding */ getBrandLogoAlt; },
/* harmony export */   "k8": function() { return /* binding */ getVehicleImageAlt; }
/* harmony export */ });
/* unused harmony exports MAIN_IMAGE_VIEW, UNKNOWN_VIEW, getVehicleAltBase, getVehicleImageView */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _dateUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73119);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Attributo ALT delle immagini dei veicoli.
 *
 * Template richiesto per la foto principale di ogni offerta:
 *   {Brand} {Modello} {Versione} {Anno} – vista laterale sinistra
 *
 * Il template si applica quando lo scatto e' davvero una laterale sinistra.
 * Quando non lo e', l'alt dichiara l'angolazione reale ricavata dall'alt che
 * arriva da offers-explorer: descrivere un'inquadratura diversa da quella
 * mostrata vale meno di un alt generico, sia per chi usa uno screen reader sia
 * per la SEO. Sulle offerte di noleggio, ad esempio, la prima foto e' quasi
 * sempre un frontale e non una laterale sinistra.
 */

const MAIN_IMAGE_VIEW = 'vista laterale sinistra';
/** Prima foto con angolazione non ricavabile: e' comunque un esterno dell'auto. */

const UNKNOWN_MAIN_VIEW = 'vista esterna';
/** Foto successive alla prima con angolazione non ricavabile. */

const UNKNOWN_VIEW = 'altra vista';
const ALT_SEPARATOR = ' – ';

/**
 * Angolazioni riconosciute, dalla piu' specifica alla piu' generica:
 * l'ordine conta perche' "Anteriore Sinistra" deve vincere su "Anteriore".
 * Le stringhe che non descrivono un'inquadratura ("Vista Identificativa",
 * "Offerta auto {Modello}") non hanno una regola di proposito: devono cadere
 * sul fallback invece di far dichiarare un'angolazione inventata.
 */
const VIEW_RULES = [{
  pattern: /(anteriore|frontale|front)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti anteriore sinistra'
}, {
  pattern: /(anteriore|frontale|front)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti anteriore destra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti posteriore sinistra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti posteriore destra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista laterale sinistra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(destr\w*|dx)/i,
  view: 'vista laterale destra'
}, {
  pattern: /(obliqu\w*|tre quarti|3\/4)/i,
  view: 'vista tre quarti'
}, {
  pattern: /(interni|abitacolo|sedili)/i,
  view: 'vista interni'
}, {
  pattern: /(plancia|cruscotto|dashboard)/i,
  view: 'vista plancia e cruscotto'
}, {
  pattern: /(bagagliaio|baule|trunk)/i,
  view: 'vista bagagliaio'
}, {
  pattern: /(cerchi|cerchio|ruote|wheel)/i,
  view: 'dettaglio cerchi'
}, {
  pattern: /(anteriore|frontale|front)/i,
  view: 'vista frontale'
}, {
  pattern: /(posteriore|retro|rear)/i,
  view: 'vista posteriore'
}, {
  pattern: /(laterale|fiancata|side)/i,
  view: 'vista laterale'
}];

const squash = value => value.replace(/\s+/g, ' ').trim();
/**
 * "{Brand} {Modello} {Versione} {Anno}".
 * Le offerte di noleggio riguardano auto nuove e non espongono un anno di
 * immatricolazione, quindi si usa l'anno corrente, coerente con title e meta
 * description. Le offerte di vendita che valorizzano `year` usano il proprio.
 */


const getVehicleAltBase = function () {
  let {
    name,
    brand,
    model,
    version,
    year
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    formattedYear
  } = (0,_dateUtils__WEBPACK_IMPORTED_MODULE_1__/* .getFormattedMonthYear */ .P)();
  const vehicleName = name || `${brand || ''} ${model || ''}`;
  return squash([vehicleName, version, `${year || formattedYear}`].filter(Boolean).join(' '));
};
/**
 * Ricava l'angolazione dall'alt di origine, null se non e' riconoscibile.
 */

const getVehicleImageView = sourceAlt => {
  if (!sourceAlt) {
    return null;
  }

  const rule = VIEW_RULES.find(_ref => {
    let {
      pattern
    } = _ref;
    return pattern.test(sourceAlt);
  });
  return rule ? rule.view : null;
};
/**
 * Alt completo di una foto veicolo. `view` e' obbligatorio: va passata
 * l'angolazione reale dello scatto, non un default.
 */

const getVehicleImageAlt = (vehicle, view) => `${getVehicleAltBase(vehicle)}${ALT_SEPARATOR}${view}`;
/**
 * Alt per le card delle liste, dove l'angolazione spesso non e' nota: viene
 * aggiunta solo se ricavabile dall'alt di origine, altrimenti si resta sul
 * veicolo piu' il contesto (es. "noleggio a lungo termine").
 */

const getOfferCardAlt = (vehicle, context, sourceAlt) => {
  const base = squash(`${getVehicleAltBase(vehicle)} ${context}`);
  const view = getVehicleImageView(sourceAlt);
  return view ? `${base}${ALT_SEPARATOR}${view}` : base;
};
/**
 * Alt dei loghi di marca, unico punto in cui si compone la stringa "Logo ...".
 *
 * Va usata ovunque compaia un logo di marca - card marchi, titolo del PDP,
 * banner partnership, heading della privacy - cosi' la forma della stringa
 * resta una sola. Il `context` opzionale aggiunge la qualifica quando serve
 * distinguere il contesto (es. "Noleggio a Lungo Termine").
 */

const getBrandLogoAlt = (brand, context) => squash(`Logo ${brand || ''} ${context || ''}`);
/**
 * Dati anagrafici di un'offerta di vendita nella forma attesa dagli helper.
 * Il dettaglio espone brand/model/version sia sulla radice sia su `vehicle`,
 * che pero' e' opzionale e viene popolato solo se l'enrichment riesce.
 */

const getSellVehicleAltData = offer => {
  var _offer$vehicle, _offer$vehicle2, _offer$vehicle3, _offer$vehicle4;

  return {
    name: (_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.name,
    brand: ((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.brand) || offer.brand,
    model: ((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.model) || offer.model,
    version: ((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.version) || offer.version,
    year: offer.year
  };
};
/**
 * Riscrive gli alt di tutte le foto della gallery mantenendo l'angolazione
 * reale dello scatto. Eventuali collisioni vengono numerate per non avere due
 * alt identici nella stessa pagina.
 */

const getGalleryImagesAlt = (images, vehicle) => {
  if (!images || !images.length) {
    return [];
  }

  const usedAlts = [];
  return images.map((image, index) => {
    const view = getVehicleImageView(image.alt) || (index === 0 ? UNKNOWN_MAIN_VIEW : UNKNOWN_VIEW);
    const baseAlt = getVehicleImageAlt(vehicle, view);
    let alt = baseAlt;
    let occurrence = 1;

    while (usedAlts.indexOf(alt) !== -1) {
      occurrence += 1;
      alt = `${baseAlt} (${occurrence})`;
    }

    usedAlts.push(alt);
    return _objectSpread(_objectSpread({}, image), {}, {
      alt
    });
  });
};

/***/ })

}]);